import * as STD from '@emersya/mpa-std-lib';
import CM       from '@emersya/mpa-components-manager-lib';

export interface ILoaderComponentConfiguration extends CM.DOMComponent.IConfiguration {
	readonly isGlobalLoader : boolean;
	readonly image : boolean | null | string | SVGElement;
};

export class LoaderComponent extends CM.DOMComponent<
	HTMLDivElement,
	LoaderComponent,
	ILoaderComponentConfiguration
>
{
	component_DOM : HTMLDivElement;

	override async component_enable() {
		document.body.style.cursor = 'wait';
		if (this.component_configuration.isGlobalLoader) {
			document.body.classList.add('globalLoading');
		}
		await super.component_enable();
	};

	override async component_disable() {
		document.body.style.cursor = '';
		if (this.component_configuration.isGlobalLoader) {
			document.body.classList.remove('globalLoading');
		}
		await super.component_disable();
	};

	override async component_start(startEvent : STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_start(startEvent);
		if (!this.component_isDisabled) {
			await this.component_enable();
		}
	};

	async update(stepId : string, progress : number | null, is0To1 = false) {
		// if (this.isDisabled) {
		await this.component_enable();
		// }
		// document.body.style.cursor = 'wait';
		const stepText = this.component_getTranslated(`step.${ stepId }`);
		const stepDOM = STD.DOM.qs(this.component_DOM, '.wrapper > .step');
		stepDOM.innerText = stepText;
		const progressDOM = STD.DOM.qs(this.component_DOM, '.wrapper > .progress');
		if (progress !== null) {
			if (is0To1) {
				progress *= 100;
			}
			progress *= 10;
			progress = Math.round(progress);
			progress /= 10;
			progressDOM.innerText = progress.toString() + '%';
		} else {
			progressDOM.innerText = '';
		}
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : ILoaderComponentConfiguration
	)
	{
		super(descriptor, Object.assign(
			{
				'@preventDefaultDisplayNone' : configuration.isGlobalLoader
			},
			configuration
		));
		this.component_disable = STD.misc.createDebouncerPromise({
			fn :    this.component_disable.bind(this),
			delay : 50
		});
		const schema : (STD.DOM.IFactoryNodePartialDescriptor | Element)[] = [
			{
				classList : [ 'step' ]
			}
		];
		if (configuration.image) {
			if (configuration.image instanceof SVGElement) {
				schema.push(configuration.image);
			} else {
				if (configuration.image === true) {
					schema.push({
						classList : [ 'image' ],
						html :      `
							<svg viewBox='-2 -1 68 67' xmlns='http://www.w3.org/2000/svg'>
								<g fill='none' fill-rule='evenodd'>
									<g transform='translate(1 1)' stroke-width='5'>
										<circle stroke-opacity='.5' cx='31' cy='31' r='31'/>
										<path d='M62 31c0-9.94-8.06-31-31-31'>
										<animateTransform attributeName='transform' type='rotate' from='0 31 31' to='360 31 31' dur='1s' repeatCount='indefinite'/>
										</path>
									</g>
								</g>
							</svg>
						`
					});
				} else {
					schema.push({
						tag :        'img',
						classList :  [ 'image' ],
						attributes : {
							src : configuration.image
						}
					});
				}
			}
		}
		schema.push({
			classList : [ 'progress' ]
		});
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({
			childs : [
				{
					classList : [ 'wrapper' ],
					childs :    schema
				}
			]
		});
		// if (this.hasTranslation('text')) {
		// 	this.DOM.dataset.translation = this.getTranslationId('text');
		// }
	};
};
export namespace NS {
	export const Component = LoaderComponent;
	export type Component = LoaderComponent;
	export type Configuration = ILoaderComponentConfiguration;
}
;
import './Loader.scss';

CM.declare({
	id :   'loader',
	type : LoaderComponent
});
